export const PortfolioGroupConstants = {
    DefaultName: "Default",
};
